import type { StandardSettings } from "@forgepoint/shared";

interface StandardSettingsFormProps {
  value: StandardSettings;
  onChange: (value: StandardSettings) => void;
}

/**
 * Settings form for the Standard "Your Tasks" template. The template is fully
 * code-defined, so there is nothing to configure beyond the org context blurb
 * the sheet renders alongside this form.
 */
export function StandardSettingsForm(_props: StandardSettingsFormProps) {
  return (
    <p className="text-sm text-muted-foreground">
      This report has no template-specific settings.
    </p>
  );
}
